/**
 * @description axios二次封装（请求延时时间，拦截器等）
 * @author xurui
 * @date 2020/06/11
 */
import axios from 'axios';
import qs from 'qs';
import router from '../../router';



// axios.defaults.baseURL = "/"
axios.defaults.baseURL = "https://api-pro.nftcn.com.cn"
// axios.defaults.baseURL = "http://api-test.nftcn.com.cn"

const services = axios.create({
	timeout: 600000, // 请求延时时间
	withCredentials: false,
});

// 需要忽略掉的请求参数，可根据实际需要更改
const ignoreParams = [null, undefined, ''];

// status -> message
const ERROR_MAPPING_MESSAGE = {
	400: '错误请求',
	401: '未授权，请重新登录',
	403: '拒绝访问',
	404: '请求错误,未找到该资源',
	405: '请求方法未允许',
	408: '请求超时',
	500: '服务器端出错',
	501: '网络未实现',
	502: '网络错误',
	503: '服务不可用',
	504: '网络超时',
	505: 'http版本不支持该请求',
};

// 请求拦截器
services.interceptors.request.use(
	(config) => {
		// 去掉需要忽略的请求参数（数据）】
		let _configParams = config.params,
			_params = {};
		for (var column in _configParams) {
			if (ignoreParams.every((item) => item !== _configParams[column])) {
				_params[column] = _configParams[column];
			}
		}
		config.params = _params;
		/**
		 * 全部请求参数添加 end
		 */
		if (config.method === 'get') {
			config.paramsSerializer = function(params) {
				return qs.stringify(params, {
					indices: false
				});
			};
		}

		if (config.url.indexOf('login') < 0) {
			// let userId = sessionStorage.getItem("userId");
			// config.headers['X-XSRF-TOKEN'] = userId;
		}
		return config;
	},
	(err) => {
		return Promise.reject(err);
	}
);

// 响应拦截器
services.interceptors.response.use(
	(config) => {
		return config.data;
	},
	(err) => {
		console.log(err);
		let _message = '',
			_retCode = 0;
		if (err && err.response) {
			_message = ERROR_MAPPING_MESSAGE[`${err.response.status}`];
			_retCode = err.response.status;
			if (_retCode === 416) {
				// 416为登陆失效
				sessionStorage.removeItem('token');
				router.push({
					path: '/login',
					query: {
						sessionIsInvalid: true,
					},
				});
			}
		}
		return Promise.resolve({
			retCode: _retCode,
			data: {},
			retMsg: _message,
		});
	}
);

export default services;
